import * as i0 from '@angular/core';
import { input, computed, Component, ViewEncapsulation } from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
const _c0 = a0 => ({
  "shimmer": a0
});
let NgxSkeletonLoadingComponent = /*#__PURE__*/(() => {
  class NgxSkeletonLoadingComponent {
    constructor() {
      this.classes = input('');
      this.height = input('100%');
      this.width = input('100%');
      this.borderRadius = input('8px');
      this.loadingEffect = input(true);
      this.style = computed(() => {
        return {
          height: this.height(),
          width: this.width(),
          borderRadius: this.borderRadius()
        };
      });
    }
    static {
      this.ɵfac = function NgxSkeletonLoadingComponent_Factory(t) {
        return new (t || NgxSkeletonLoadingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxSkeletonLoadingComponent,
        selectors: [["lib-ngx-skeleton-loading"]],
        inputs: {
          classes: [i0.ɵɵInputFlags.SignalBased, "classes"],
          height: [i0.ɵɵInputFlags.SignalBased, "height"],
          width: [i0.ɵɵInputFlags.SignalBased, "width"],
          borderRadius: [i0.ɵɵInputFlags.SignalBased, "borderRadius"],
          loadingEffect: [i0.ɵɵInputFlags.SignalBased, "loadingEffect"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 7,
        consts: [[3, "ngClass", "ngStyle"]],
        template: function NgxSkeletonLoadingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵclassMapInterpolate1("skeleton bg-tint ", ctx.classes(), "");
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c0, ctx.loadingEffect()))("ngStyle", ctx.style());
          }
        },
        dependencies: [NgStyle, NgClass],
        styles: [":root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:root .inverted{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}:root .dark .inverted{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}:host{display:block}.skeleton{max-width:100%;max-height:100%;cursor:progress;display:block}.skeleton.shimmer{background-size:200%;background-image:linear-gradient(90deg,var(--shimmer-first-color),var(--shimmer-second-color),var(--shimmer-third-color));animation:shimmer 1.5s infinite reverse}@keyframes shimmer{0%{background-position:-100% 0}50%{background-position:0 0}to{background-position:100% 0}}\n"],
        encapsulation: 2
      });
    }
  }
  return NgxSkeletonLoadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-skeleton-loading
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSkeletonLoadingComponent };
